<script setup lang="ts">
import { computed } from 'vue'
import type { ToastVariant } from '@/composables/useToast'

const props = defineProps<{ message: string; variant: ToastVariant }>()
defineEmits<{ dismiss: [] }>()

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'success':
      return 'bg-mint/30 text-teal-light'
    case 'error':
      return 'bg-red-100 text-red-700'
    default:
      return 'bg-navy text-cream'
  }
})

const icon = computed(() => (props.variant === 'success' ? '✓' : props.variant === 'error' ? '!' : 'i'))
</script>

<template>
  <div
    class="flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-semibold shadow-lg"
    :class="variantClasses"
    role="status"
  >
    <span class="flex size-5 shrink-0 items-center justify-center rounded-full bg-white/30 text-xs font-bold">
      {{ icon }}
    </span>
    <span class="flex-1">{{ message }}</span>
    <button
      type="button"
      aria-label="Dismiss"
      class="shrink-0 opacity-60 hover:opacity-100"
      @click="$emit('dismiss')"
    >
      ✕
    </button>
  </div>
</template>

<style scoped></style>
